import { createSlice } from '@reduxjs/toolkit';
import { createBatchDetail, IBatch, IBatchOpen } from '../../../models/batches';
import { IBatchShipped } from '../../../models/batches/batchShipped';
import { IBatchTrackingNumber } from '../../../models/batches/batchTrackingNumber';
import { IStudentPerBatches } from '../../../models/students';

interface IBatchOpenState {
    batchesGrouped: IBatch[],
    batchesOpen: IBatchOpen[],
    currentBatch: IBatchOpen,
    studentsBatches: IStudentPerBatches[],
    batchesTrackingNumber: IBatchTrackingNumber[],
    isLoading: boolean,
    batchesShipped: IBatchShipped[],
};

const initialState: IBatchOpenState = {
    batchesGrouped: [],
    batchesOpen: [],
    currentBatch: createBatchDetail({}),
    studentsBatches: [],
    batchesTrackingNumber: [],
    isLoading: false,
    batchesShipped: []
};

export const batchesSlice = createSlice({
    name: 'batches',
    initialState,
    reducers: {
        setBatchesOpen: (state, action) => {
            state.isLoading = false;
            state.batchesGrouped = action.payload.batchesGrouped;
            state.batchesOpen = action.payload.batchesOpen;
        },
        setBatchesShipped: (state, action) => {
            state.isLoading = false;
            state.batchesShipped = action.payload.batchesShipped;
        },
        setStudentsByOpenBatch: (state, action) => {
            state.isLoading = false;
            state.studentsBatches = action.payload.studentsBatches;
        },
        setBatchTrackingNumber: (state, action) => {
            state.isLoading = false;
            state.batchesTrackingNumber = action.payload.batchesTrackingNumber;
        },
        setBatchOpen: (state, action) => {
            state.isLoading = false;
            state.currentBatch = action.payload.currentBatch;
        },
        startLoadingBatchesOpen: (state) => {
            state.isLoading = true;
        },
        stopLoadingBatchesOpen: (state) => {
            state.isLoading = false;
        }
    }
});

// Action creators are generated for each case reducer function
export const {
    setBatchesOpen,
    setBatchOpen,
    setBatchesShipped,
    setStudentsByOpenBatch,
    startLoadingBatchesOpen,
    setBatchTrackingNumber,
    stopLoadingBatchesOpen
} = batchesSlice.actions;